import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/products', label: 'Products' },
    { path: '/services', label: 'Services' },
    { path: '/news', label: 'News' },
    { path: '/contact', label: 'Contact' }
  ];

  const productCategories = [
    'TMT Bars',
    'Round Bars',
    'Flat Bars',
    'Structural Steel',
    'Steel Sheets & Plates',
    'Steel Coils',
    'Pipes & Tubes',
    'Angles & Channels'
  ];

  return (
    <footer className="bg-slate-900 text-slate-300">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img 
                src="/images/ga-ispat-logo.png" 
                alt="G.A ISPAT Pvt. Ltd." 
                className="h-20 w-auto"
              />
            </Link>
            <p className="text-sm mb-6 text-slate-400 leading-relaxed">
              Your trusted partner in steel supply since 2007. Specializing in TMT bars, round bars, and structural steel with excellent service across India.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-orange-600 rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-orange-600 rounded-lg flex items-center justify-center transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-orange-600 rounded-lg flex items-center justify-center transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-orange-600 rounded-lg flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-slate-400 hover:text-orange-500 transition-colors inline-block"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Our Products</h3>
            <ul className="space-y-3">
              {productCategories.map((product, index) => (
                <li key={index}>
                  <Link
                    to="/products"
                    className="text-sm text-slate-400 hover:text-orange-500 transition-colors inline-block"
                  >
                    {product}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-slate-400">
                  11A, Maharishi Debendra Road<br />
                  Burrabazar, Kolkata<br />
                  West Bengal, India - 700007
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-orange-500 flex-shrink-0" />
                <div className="text-sm text-slate-400">
                  <a href="tel:+919007396826" className="hover:text-orange-500 transition-colors block">+91 9007396826</a>
                  <a href="tel:+919831170100" className="hover:text-orange-500 transition-colors block">+91 9831170100</a>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-orange-500 flex-shrink-0" />
                <a href="mailto:gaispatpvtltd@gmail.com" className="text-sm text-slate-400 hover:text-orange-500 transition-colors">
                  gaispatpvtltd@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
            <p>&copy; {new Date().getFullYear()} G.A ISPAT Pvt. Ltd. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="#" className="hover:text-orange-500 transition-colors">Privacy Policy</Link>
              <Link to="#" className="hover:text-orange-500 transition-colors">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
